// extracted by mini-css-extract-plugin
module.exports = {"container":"Child_container__2X4C-","checkbox":"Child_checkbox__tOJlx","checkbox_fake":"Child_checkbox_fake__2UPeP","remove":"Child_remove__2RhAb"};